/* Urban Customz — count-up numbers.
   Each [data-uc-count] element already contains its final value as text, so the
   page is correct without JavaScript, with reduced motion, or if this file fails
   to load. When it does run, the number counts up once as it enters view and then
   keeps its final value — it is never tied to reversible scroll progress. */
(() => {
  if (window.__ucCountReady) return;
  window.__ucCountReady = true;

  const DURATION = 1400;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const format = (n, locale) => {
    try {
      return new Intl.NumberFormat(locale || undefined).format(n);
    } catch (err) {
      return String(n);
    }
  };

  const run = (el) => {
    if (el.dataset.ucCounted) return;
    el.dataset.ucCounted = '1';
    // The finished figure is already in the HTML, exactly as it should read.
    const finalText = el.textContent.trim();
    const target = Number((el.dataset.ucCount || finalText).replace(/[^0-9.]/g, ''));
    if (!isFinite(target) || target <= 0 || reduced()) return;
    const locale = el.dataset.ucLocale || document.documentElement.lang;
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / DURATION);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = format(Math.round(target * eased), locale);
      if (t < 1) requestAnimationFrame(step);
      else el.textContent = finalText;
    };
    el.textContent = format(0, locale);
    requestAnimationFrame(step);
  };

  let observer = null;
  const watch = (el) => {
    if (!('IntersectionObserver' in window)) return run(el);
    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            run(entry.target);
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0.35 }
      );
    }
    observer.observe(el);
  };

  const init = (scope) => (scope || document).querySelectorAll('[data-uc-count]').forEach(watch);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-uc-count]').forEach((el) => {
      delete el.dataset.ucCounted;
      watch(el);
    });
  });
})();
